import { render, staticRenderFns } from "./TrailerListingDataChips.vue?vue&type=template&id=a281de0a&scoped=true"
import script from "./TrailerListingDataChips.vue?vue&type=script&lang=js"
export * from "./TrailerListingDataChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a281de0a",
  null
  
)

export default component.exports